export const transportDtoStatusEnum = {
  '1': 1,
  '2': 2,
} as const

export type TransportDtoStatusEnum = (typeof transportDtoStatusEnum)[keyof typeof transportDtoStatusEnum]

export type TransportDto = {
  /**
   * @type number
   */
  status: TransportDtoStatusEnum
  /**
   * @type number
   */
  id: number
  /**
   * @type string
   */
  brand: string | null
  /**
   * @type string
   */
  model: string | null
  /**
   * @type string
   */
  plate_number: string | null
  /**
   * @type string
   */
  category: string | null
  /**
   * @type string
   */
  description: string | null
  /**
   * @type number
   */
  school_id: number
}